import React from 'react';
import PubSub from 'pubsub-js';

import Constants from './../../constants';
import MixcloudEmbed from './mixcloudEmbed';
import SoundcloudEmbed from './soundcloudEmbed';

module.exports = React.createClass({
  propTypes: {
    selectedMixcloudLink: React.PropTypes.string.isRequired,
    selectedSoundcloudEmbed: React.PropTypes.string.isRequired,
  },
  
  clearMixcloud: function clearMixcloud() {
    PubSub.publish(Constants.PUB_SUB_LABEL.MIXCLOUD_URL, '');
  },

  clearEmbeds: function clearEmbeds() {
    PubSub.publish(Constants.PUB_SUB_LABEL.MIXCLOUD_URL, '');
    PubSub.publish(Constants.PUB_SUB_LABEL.SOUNDCLOUD_EMBED, '');
  },

  render: function render() {
    if (this.props.selectedMixcloudLink && this.props.selectedMixcloudLink.length) {
      return <MixcloudEmbed onBackClicked={ this.clearEmbeds } link={ this.props.selectedMixcloudLink }/>;
    } else if (this.props.selectedSoundcloudEmbed && this.props.selectedSoundcloudEmbed.length) {
      return <SoundcloudEmbed onBackClicked={ this.clearEmbeds } embed={ this.props.selectedSoundcloudEmbed }/>;
    }
    return null;
  },
});
